import React from "react";
import { OrderMissionEntity } from "@src/features/order/entities";
import HistoryOrderRoute from "../history-order-route";

interface ErrorMapProps {
  order: OrderMissionEntity;
}

const ErrorMap: React.FC<ErrorMapProps> = ({ order }) => {
  if (!order) return null;
  return <HistoryOrderRoute order={order} droneVariant="error" />;
};

export default ErrorMap;
